import {Language} from '@/ts/types/component/localization.type';
import {PublicPath} from '@/ts/router/pages-path';

/** Query parameter values identifying voucher code partners during sign-up */
export enum VoucherCodeQuery {
  URBAN_SPORTS_CLUB = 'urban',
  ZIM_STUDY = 'zim',
  ALLIANZ = 'allianz',
}

/** Identifiers for each step in the registration wizard flow */
export enum RegistrationStepId {
  EMAIL = 'EMAIL',
  USER_DATA = 'USER_DATA',
  CONSENT = 'CONSENT',
  TRIAL = 'TRIAL',
  CAPTCHA = 'CAPTCHA',
}

/**
 * Checks if the current URL contains the specified voucher code on signup page and returns the appropriate language
 * @param code - The voucher code to check for
 * @returns Language if the code is found in URL on signup page, null otherwise
 */
export function getLanguageForVoucherCode(code: VoucherCodeQuery): Language | null {
  const currentUrl = typeof window === 'undefined' ? '' : window.location.href;

  if ((currentUrl?.includes(`code=${code}`) ?? false) && (currentUrl?.includes(PublicPath.signUp) ?? false)) {
    if (code === VoucherCodeQuery.ALLIANZ) {
      return Language.German;
    }
    // Use default language detection for other codes
    return null;
  }

  return null;
}
